import { Modal } from "../../shared/ui/Modal";
import styles from "./RenameModal.module.scss";
import { NormalButton } from "../../shared/ui/Button";
import { useState } from "react";
import { Input } from "../../shared/ui/Input";
import { CancelButton } from "@/frontend/shared/ui/Button/CancelButton/CancelButton";

interface RenameModalProps {
  isOpen: boolean;
  value: string;
  setValue: (value: string) => void;
  onClose: () => void;
  onSuccess: () => void;
  title: string;
  placeholder?: string;
  restrictedOptions?: string[];
  isDisabled?: boolean;
  lengthLimit?: number;
  valueName?: string;
}

export function RenameModal({
  isOpen,
  value,
  setValue,
  onClose,
  onSuccess,
  title,
  placeholder,
  isDisabled,
  restrictedOptions,
  lengthLimit,
  valueName
}: RenameModalProps) {
  const [inputError, setInputError] = useState<string>("");

  function validateInput(value: string): boolean {
    let hasErrors = false;
    const name = valueName || "Value";
    if (!!lengthLimit && value.length > lengthLimit) {
      setInputError(`${name} name is too long`);
      hasErrors = true;
    }

    if (restrictedOptions && restrictedOptions.includes(value)) {
      setInputError(`${name} with this name already exists`);
      hasErrors = true;
    }

    return hasErrors;
  }

  function onSubmit() {
    const hasErrors = validateInput(value);
    if (hasErrors) {
      return;
    }
    onSuccess();
  }

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} title={title || "Rename"} minHeight="240px">
        <div>
          <Input
            placeholder={placeholder || "Enter new name"}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setInputError("");
            }}
            className={styles.renameInput}
            error={inputError}
          />
        </div>
        <div className={styles.optionContainer}>
          <CancelButton size="large" onClick={onClose}>
            Cancel
          </CancelButton>
          <NormalButton size="large" onClick={onSubmit} isDisabled={!value || isDisabled}>
            Save
          </NormalButton>
        </div>
      </Modal>
    </div>
  );
}
